const stroke = {
  name: "stroke",
  path: "/stroke",
  title: "stroke",
  description: "Utilities for styling the stroke of SVG elements.",
  value: {
  "stroke": {
    "stroke-none": "none",
    "stroke-color-inherit": "inherit",
    "stroke-color-current": "currentColor",
    "stroke-color-transparent": "transparent",
    "stroke-color-[<value>]": "<value>",
    "stroke-color-black": "var(--color-black)",
    "stroke-color-white": "var(--color-white)",
    "stroke-color-red-50": "var(--color-red-50)",
    "stroke-color-red-100": "var(--color-red-100)",
    "stroke-color-red-200": "var(--color-red-200)",
    "stroke-color-red-300": "var(--color-red-300)",
    "stroke-color-red-400": "var(--color-red-400)",
    "stroke-color-red-500": "var(--color-red-500)",
    "stroke-color-red-600": "var(--color-red-600)",
    "stroke-color-red-700": "var(--color-red-700)",
    "stroke-color-red-800": "var(--color-red-800)",
    "stroke-color-red-900": "var(--color-red-900)",
    "stroke-color-orange-50": "var(--color-orange-50)",
    "stroke-color-orange-100": "var(--color-orange-100)",
    "stroke-color-orange-200": "var(--color-orange-200)",
    "stroke-color-orange-300": "var(--color-orange-300)",
    "stroke-color-orange-400": "var(--color-orange-400)",
    "stroke-color-orange-500": "var(--color-orange-500)",
    "stroke-color-orange-600": "var(--color-orange-600)",
    "stroke-color-orange-700": "var(--color-orange-700)",
    "stroke-color-orange-800": "var(--color-orange-800)",
    "stroke-color-orange-900": "var(--color-orange-900)",
    "stroke-color-amber-50": "var(--color-amber-50)",
    "stroke-color-amber-100": "var(--color-amber-100)",
    "stroke-color-amber-200": "var(--color-amber-200)",
    "stroke-color-amber-300": "var(--color-amber-300)",
    "stroke-color-amber-400": "var(--color-amber-400)",
    "stroke-color-amber-500": "var(--color-amber-500)",
    "stroke-color-amber-600": "var(--color-amber-600)",
    "stroke-color-amber-700": "var(--color-amber-700)",
    "stroke-color-amber-800": "var(--color-amber-800)",
    "stroke-color-amber-900": "var(--color-amber-900)",
    "stroke-color-yellow-50": "var(--color-yellow-50)",
    "stroke-color-yellow-100": "var(--color-yellow-100)",
    "stroke-color-yellow-200": "var(--color-yellow-200)",
    "stroke-color-yellow-300": "var(--color-yellow-300)",
    "stroke-color-yellow-400": "var(--color-yellow-400)",
    "stroke-color-yellow-500": "var(--color-yellow-500)",
    "stroke-color-yellow-600": "var(--color-yellow-600)",
    "stroke-color-yellow-700": "var(--color-yellow-700)",
    "stroke-color-yellow-800": "var(--color-yellow-800)",
    "stroke-color-yellow-900": "var(--color-yellow-900)",
    "stroke-color-lime-50": "var(--color-lime-50)",
    "stroke-color-lime-100": "var(--color-lime-100)",
    "stroke-color-lime-200": "var(--color-lime-200)",
    "stroke-color-lime-300": "var(--color-lime-300)",
    "stroke-color-lime-400": "var(--color-lime-400)",
    "stroke-color-lime-500": "var(--color-lime-500)",
    "stroke-color-lime-600": "var(--color-lime-600)",
    "stroke-color-lime-700": "var(--color-lime-700)",
    "stroke-color-lime-800": "var(--color-lime-800)",
    "stroke-color-lime-900": "var(--color-lime-900)",
    "stroke-color-green-50": "var(--color-green-50)",
    "stroke-color-green-100": "var(--color-green-100)",
    "stroke-color-green-200": "var(--color-green-200)",
    "stroke-color-green-300": "var(--color-green-300)",
    "stroke-color-green-400": "var(--color-green-400)",
    "stroke-color-green-500": "var(--color-green-500)",
    "stroke-color-green-600": "var(--color-green-600)",
    "stroke-color-green-700": "var(--color-green-700)",
    "stroke-color-green-800": "var(--color-green-800)",
    "stroke-color-green-900": "var(--color-green-900)",
    "stroke-color-emerald-50": "var(--color-emerald-50)",
    "stroke-color-emerald-100": "var(--color-emerald-100)",
    "stroke-color-emerald-200": "var(--color-emerald-200)",
    "stroke-color-emerald-300": "var(--color-emerald-300)",
    "stroke-color-emerald-400": "var(--color-emerald-400)",
    "stroke-color-emerald-500": "var(--color-emerald-500)",
    "stroke-color-emerald-600": "var(--color-emerald-600)",
    "stroke-color-emerald-700": "var(--color-emerald-700)",
    "stroke-color-emerald-800": "var(--color-emerald-800)",
    "stroke-color-emerald-900": "var(--color-emerald-900)",
    "stroke-color-teal-50": "var(--color-teal-50)",
    "stroke-color-teal-100": "var(--color-teal-100)",
    "stroke-color-teal-200": "var(--color-teal-200)",
    "stroke-color-teal-300": "var(--color-teal-300)",
    "stroke-color-teal-400": "var(--color-teal-400)",
    "stroke-color-teal-500": "var(--color-teal-500)",
    "stroke-color-teal-600": "var(--color-teal-600)",
    "stroke-color-teal-700": "var(--color-teal-700)",
    "stroke-color-teal-800": "var(--color-teal-800)",
    "stroke-color-teal-900": "var(--color-teal-900)",
    "stroke-color-cyan-50": "var(--color-cyan-50)",
    "stroke-color-cyan-100": "var(--color-cyan-100)",
    "stroke-color-cyan-200": "var(--color-cyan-200)",
    "stroke-color-cyan-300": "var(--color-cyan-300)",
    "stroke-color-cyan-400": "var(--color-cyan-400)",
    "stroke-color-cyan-500": "var(--color-cyan-500)",
    "stroke-color-cyan-600": "var(--color-cyan-600)",
    "stroke-color-cyan-700": "var(--color-cyan-700)",
    "stroke-color-cyan-800": "var(--color-cyan-800)",
    "stroke-color-cyan-900": "var(--color-cyan-900)",
    "stroke-color-sky-50": "var(--color-sky-50)",
    "stroke-color-sky-100": "var(--color-sky-100)",
    "stroke-color-sky-200": "var(--color-sky-200)",
    "stroke-color-sky-300": "var(--color-sky-300)",
    "stroke-color-sky-400": "var(--color-sky-400)",
    "stroke-color-sky-500": "var(--color-sky-500)",
    "stroke-color-sky-600": "var(--color-sky-600)",
    "stroke-color-sky-700": "var(--color-sky-700)",
    "stroke-color-sky-800": "var(--color-sky-800)",
    "stroke-color-sky-900": "var(--color-sky-900)",
    "stroke-color-blue-50": "var(--color-blue-50)",
    "stroke-color-blue-100": "var(--color-blue-100)",
    "stroke-color-blue-200": "var(--color-blue-200)",
    "stroke-color-blue-300": "var(--color-blue-300)",
    "stroke-color-blue-400": "var(--color-blue-400)",
    "stroke-color-blue-500": "var(--color-blue-500)",
    "stroke-color-blue-600": "var(--color-blue-600)",
    "stroke-color-blue-700": "var(--color-blue-700)",
    "stroke-color-blue-800": "var(--color-blue-800)",
    "stroke-color-blue-900": "var(--color-blue-900)",
    "stroke-color-indigo-50": "var(--color-indigo-50)",
    "stroke-color-indigo-100": "var(--color-indigo-100)",
    "stroke-color-indigo-200": "var(--color-indigo-200)",
    "stroke-color-indigo-300": "var(--color-indigo-300)",
    "stroke-color-indigo-400": "var(--color-indigo-400)",
    "stroke-color-indigo-500": "var(--color-indigo-500)",
    "stroke-color-indigo-600": "var(--color-indigo-600)",
    "stroke-color-indigo-700": "var(--color-indigo-700)",
    "stroke-color-indigo-800": "var(--color-indigo-800)",
    "stroke-color-indigo-900": "var(--color-indigo-900)",
    "stroke-color-violet-50": "var(--color-violet-50)",
    "stroke-color-violet-100": "var(--color-violet-100)",
    "stroke-color-violet-200": "var(--color-violet-200)",
    "stroke-color-violet-300": "var(--color-violet-300)",
    "stroke-color-violet-400": "var(--color-violet-400)",
    "stroke-color-violet-500": "var(--color-violet-500)",
    "stroke-color-violet-600": "var(--color-violet-600)",
    "stroke-color-violet-700": "var(--color-violet-700)",
    "stroke-color-violet-800": "var(--color-violet-800)",
    "stroke-color-violet-900": "var(--color-violet-900)",
    "stroke-color-purple-50": "var(--color-purple-50)",
    "stroke-color-purple-100": "var(--color-purple-100)",
    "stroke-color-purple-200": "var(--color-purple-200)",
    "stroke-color-purple-300": "var(--color-purple-300)",
    "stroke-color-purple-400": "var(--color-purple-400)",
    "stroke-color-purple-500": "var(--color-purple-500)",
    "stroke-color-purple-600": "var(--color-purple-600)",
    "stroke-color-purple-700": "var(--color-purple-700)",
    "stroke-color-purple-800": "var(--color-purple-800)",
    "stroke-color-purple-900": "var(--color-purple-900)",
    "stroke-color-fuchsia-50": "var(--color-fuchsia-50)",
    "stroke-color-fuchsia-100": "var(--color-fuchsia-100)",
    "stroke-color-fuchsia-200": "var(--color-fuchsia-200)",
    "stroke-color-fuchsia-300": "var(--color-fuchsia-300)",
    "stroke-color-fuchsia-400": "var(--color-fuchsia-400)",
    "stroke-color-fuchsia-500": "var(--color-fuchsia-500)",
    "stroke-color-fuchsia-600": "var(--color-fuchsia-600)",
    "stroke-color-fuchsia-700": "var(--color-fuchsia-700)",
    "stroke-color-fuchsia-800": "var(--color-fuchsia-800)",
    "stroke-color-fuchsia-900": "var(--color-fuchsia-900)",
    "stroke-color-pink-50": "var(--color-pink-50)",
    "stroke-color-pink-100": "var(--color-pink-100)",
    "stroke-color-pink-200": "var(--color-pink-200)",
    "stroke-color-pink-300": "var(--color-pink-300)",
    "stroke-color-pink-400": "var(--color-pink-400)",
    "stroke-color-pink-500": "var(--color-pink-500)",
    "stroke-color-pink-600": "var(--color-pink-600)",
    "stroke-color-pink-700": "var(--color-pink-700)",
    "stroke-color-pink-800": "var(--color-pink-800)",
    "stroke-color-pink-900": "var(--color-pink-900)",
    "stroke-color-rose-50": "var(--color-rose-50)",
    "stroke-color-rose-100": "var(--color-rose-100)",
    "stroke-color-rose-200": "var(--color-rose-200)",
    "stroke-color-rose-300": "var(--color-rose-300)",
    "stroke-color-rose-400": "var(--color-rose-400)",
    "stroke-color-rose-500": "var(--color-rose-500)",
    "stroke-color-rose-600": "var(--color-rose-600)",
    "stroke-color-rose-700": "var(--color-rose-700)",
    "stroke-color-rose-800": "var(--color-rose-800)",
    "stroke-color-rose-900": "var(--color-rose-900)",
    "stroke-color-slate-50": "var(--color-slate-50)",
    "stroke-color-slate-100": "var(--color-slate-100)",
    "stroke-color-slate-200": "var(--color-slate-200)",
    "stroke-color-slate-300": "var(--color-slate-300)",
    "stroke-color-slate-400": "var(--color-slate-400)",
    "stroke-color-slate-500": "var(--color-slate-500)",
    "stroke-color-slate-600": "var(--color-slate-600)",
    "stroke-color-slate-700": "var(--color-slate-700)",
    "stroke-color-slate-800": "var(--color-slate-800)",
    "stroke-color-slate-900": "var(--color-slate-900)",
    "stroke-color-gray-50": "var(--color-gray-50)",
    "stroke-color-gray-100": "var(--color-gray-100)",
    "stroke-color-gray-200": "var(--color-gray-200)",
    "stroke-color-gray-300": "var(--color-gray-300)",
    "stroke-color-gray-400": "var(--color-gray-400)",
    "stroke-color-gray-500": "var(--color-gray-500)",
    "stroke-color-gray-600": "var(--color-gray-600)",
    "stroke-color-gray-700": "var(--color-gray-700)",
    "stroke-color-gray-800": "var(--color-gray-800)",
    "stroke-color-gray-900": "var(--color-gray-900)",
    "stroke-color-zinc-50": "var(--color-zinc-50)",
    "stroke-color-zinc-100": "var(--color-zinc-100)",
    "stroke-color-zinc-200": "var(--color-zinc-200)",
    "stroke-color-zinc-300": "var(--color-zinc-300)",
    "stroke-color-zinc-400": "var(--color-zinc-400)",
    "stroke-color-zinc-500": "var(--color-zinc-500)",
    "stroke-color-zinc-600": "var(--color-zinc-600)",
    "stroke-color-zinc-700": "var(--color-zinc-700)",
    "stroke-color-zinc-800": "var(--color-zinc-800)",
    "stroke-color-zinc-900": "var(--color-zinc-900)",
    "stroke-color-neutral-50": "var(--color-neutral-50)",
    "stroke-color-neutral-100": "var(--color-neutral-100)",
    "stroke-color-neutral-200": "var(--color-neutral-200)",
    "stroke-color-neutral-300": "var(--color-neutral-300)",
    "stroke-color-neutral-400": "var(--color-neutral-400)",
    "stroke-color-neutral-500": "var(--color-neutral-500)",
    "stroke-color-neutral-600": "var(--color-neutral-600)",
    "stroke-color-neutral-700": "var(--color-neutral-700)",
    "stroke-color-neutral-800": "var(--color-neutral-800)",
    "stroke-color-neutral-900": "var(--color-neutral-900)",
    "stroke-color-stone-50": "var(--color-stone-50)",
    "stroke-color-stone-100": "var(--color-stone-100)",
    "stroke-color-stone-200": "var(--color-stone-200)",
    "stroke-color-stone-300": "var(--color-stone-300)",
    "stroke-color-stone-400": "var(--color-stone-400)",
    "stroke-color-stone-500": "var(--color-stone-500)",
    "stroke-color-stone-600": "var(--color-stone-600)",
    "stroke-color-stone-700": "var(--color-stone-700)",
    "stroke-color-stone-800": "var(--color-stone-800)",
    "stroke-color-stone-900": "var(--color-stone-900)"
  }
},
  exampleData: [
    {
      example: {
        code: `<svg class="stroke-color-cyan-500 fill-color-white hover:fill-color-cyan-500 hover:stroke-color-white ...">
  <!-- ... -->
</svg>
        `
      }
    },
    {
      example: {
        code: `<div class="text-color-purple-500 ...">
   <svg class="stroke-color-current" >
   <!-- ... -->
   </svg>
</div>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">stroke-color-*</code> to change the stroke color of an SVG:
      </p>
      
      <div class="flex items-center justify-center">
   <svg class="h-10 stroke-color-cyan-500 fill-color-transparent hover:stroke-color-white" viewBox="0 0 48 40">
   <path d="M1 13C1 10.2386 3.23858 8 6 8H13.4914C14.3844 8 15.1691 7.40805 15.4144 6.54944L16.5856 2.45056C16.8309 1.59196 17.6156 1 18.5086 1H29.4914C30.3844 1 31.1691 1.59195 31.4144 2.45056L32.5856 6.54944C32.8309 7.40804 33.6156 8 34.5086 8H42C44.7614 8 47 10.2386 47 13V34C47 36.7614 44.7614 39 42 39H6C3.23858 39 1 36.7614 1 34V13Z" stroke-width="2"></path><circle cx="24" cy="23" r="9" stroke-width="2"></circle>
   </svg>
</div>
    `
  },
      {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">stroke-color-current</code> utility to set the stroke color to the current text color:
      </p>
      
      <div class="flex items-center justify-center text-color-purple-500">
   <svg class="h-10 stroke-color-current" viewBox="0 0 48 40" fill="none">
   <path d="M1 13C1 10.2386 3.23858 8 6 8H13.4914C14.3844 8 15.1691 7.40805 15.4144 6.54944L16.5856 2.45056C16.8309 1.59196 17.6156 1 18.5086 1H29.4914C30.3844 1 31.1691 1.59195 31.4144 2.45056L32.5856 6.54944C32.8309 7.40804 33.6156 8 34.5086 8H42C44.7614 8 47 10.2386 47 13V34C47 36.7614 44.7614 39 42 39H6C3.23858 39 1 36.7614 1 34V13Z" stroke-width="2"></path><circle cx="24" cy="23" r="9" stroke-width="2"></circle>
   </svg>
</div>
    `
  }
]
}
export default stroke;

<div class="sr-only stroke-color-cyan-500 fill-color-transparent stroke-color-current text-color-purple-500 fill-color-white hover:fill-color-cyan-500 hover:stroke-color-white">

</div>